import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { CONTACTS_CRUD_ACTION_CREATORS } from '../actions/contacts_actions';

export const contactsRestCrudThunksForBuyer = new RestCrudThunks(
	'',
	'contact',
	'contact',
	'contacts',
	CONTACTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'common_contacts'
);
export const contactsRestCrudThunksForSupplier = new RestCrudThunks(
	'',
	'contact',
	'contact',
	'contacts',
	CONTACTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'common_contacts'
);

export const getContactsRestCrudThunksWithInternalTechs = (userType: string) =>
	new RestCrudThunks(
		'/buyer_internal_team_users_list',
		'contact',
		'contact',
		'contacts',
		CONTACTS_CRUD_ACTION_CREATORS,
		null,
		userType,
		false,
		'common_contacts'
	);

export const contactsRestCrudThunksForSupplierForThirdPartySuppliers = new RestCrudThunks(
	'/supplier_users_list',
	'contact',
	'contact',
	'contacts',
	CONTACTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'common_contacts'
);
